import React from 'react';
import ModuleEditOptionsSection from "../ModuleEditOptionsSection";
import TotalSystemEfficiency
    from "../../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/TotalSystemEfficiency";
import RoofInformationTable
    from "../../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/RoofInformationTable";

const ProductionTabIpad: React.FC = () => {

    return (
        <div className='tab__inner'>
            <ModuleEditOptionsSection/>
            <div className='tab__column'>
                <div className='tab__column' style={{padding: "10px"}}>
                    <span className='tab__column--title'>Total System Efficiency</span>
                    <TotalSystemEfficiency popoutVersion={false}/>
                    <span className='tab__column--title' style={{position: "relative"}}>Roof Information Table</span>
                    <RoofInformationTable shortened={true}/>
                </div> 
            </div>
        </div>
    );
}

export default ProductionTabIpad;